import { randomInt } from "./generator";

const NON_EXISTENT_INDEX = -1;

function range(stop: number): number[];
function range(start: number, stop: number): number[];
function range(start: number, stop: number, step: number): number[];
function range(startOrStop: number, stop_?: number, step = 1) {
  if (step === 0) {
    throw new RangeError('"step" must not be zero');
  }

  const [start, stop] = stop_ === undefined ? [0, startOrStop] : [startOrStop, stop_];

  const values = [];

  for (let i = 0; ; ++i) {
    const value = start + step * i;
    if (step > 0 ? value < stop : value > stop) {
      values.push(value);
    } else {
      break;
    }
  }

  return values;
}

function getRandomElement<T>(values: T[]) {
  return values[randomInt(0, values.length)];
}

type CallbackFn<T, U> = (item: T, index: number, array: T[]) => U;

function sum(values: number[], initialValue?: number): number;
function sum<T>(values: T[], getValue: CallbackFn<T, number>, initialValue?: number): number;
function sum<T>(
  values: T[],
  initialValueOrGetValue: number | CallbackFn<T, number> = 0,
  initialValue = 0,
) {
  const [getValue, initialValue_] =
    typeof initialValueOrGetValue === "number"
      ? [
          () => {
            throw new TypeError();
          },
          initialValueOrGetValue,
        ]
      : [initialValueOrGetValue, initialValue];

  return values.reduce(
    (total, item, index, array) =>
      total + (typeof item === "number" ? item : getValue(item, index, array)),
    initialValue_,
  );
}
function intersection<T>(first: Set<T>, second: Set<T>, compare?: (a: T, b: T) => boolean) {
  const secondAsArray = [...second];
  return [...first].filter((a) => secondAsArray.some((b) => compare?.(a, b) ?? a === b));
}

function getOrThrowIfUndefined<T>(values: T[], index: number): T {
  const value = values[index];
  if (value === undefined)
    throw new Error(
      `Array of length ${values.length} does not contain an element with index ${index}`,
    );

  return value;
}

export { getOrThrowIfUndefined, getRandomElement, intersection, NON_EXISTENT_INDEX, range, sum };
